
window.addEventListener('DOMContentLoaded', run);

async function run(e) {
    lazyLoadYoutube();
}


function lazyLoadYoutube() {

    const videos = document.querySelectorAll('.youtube');

    for (var i = 0; i < videos.length; i++) {

        const video = videos[i];
        video.addEventListener('click', function () {

            var iframe = document.createElement('iframe');

            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + this.dataset.ytid + '?rel=0&showinfo=0&autoplay=1');

            this.innerHTML = '';
            this.appendChild(iframe);
        });
    };
}
